// "Se den på din væg" (snippets/wall-picker.liquid): paints the wall panel
// behind the product drawing in the picked colour. Purely visual: nothing is
// sent with the order. The choice is remembered in this browser, so it
// carries over from one size to the next.
(function () {
  var picker = document.querySelector('[data-wall-picker]');
  var scene = document.querySelector('[data-wall-scene]');
  if (!picker || !scene) return;

  var KEY = 'studieh-wall';
  var dots = [].slice.call(picker.querySelectorAll('[data-wall]'));
  var custom = picker.querySelector('[data-wall-custom]');
  var customDot = custom ? custom.closest('.wall-picker__dot') : null;
  var HEX = /^#[0-9a-f]{6}$/i;

  // Light or dark wall, so text and check marks on it can switch colour.
  function isDark(hex) {
    var n = parseInt(hex.slice(1), 16);
    var lin = [n >> 16, (n >> 8) & 255, n & 255].map(function (v) {
      v /= 255;
      return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
    });
    return 0.2126 * lin[0] + 0.7152 * lin[1] + 0.0722 * lin[2] < 0.22;
  }

  function apply(hex, source) {
    var on = HEX.test(hex || '');
    scene.classList.toggle('has-wall', on);
    scene.classList.toggle('is-dark-wall', on && isDark(hex));
    if (on) scene.style.setProperty('--wall', hex);
    else scene.style.removeProperty('--wall');

    var matched = false;
    dots.forEach(function (d) {
      var hit = d.dataset.wall.toLowerCase() === (on ? hex.toLowerCase() : '');
      if (hit) matched = true;
      d.setAttribute('aria-pressed', String(hit));
    });
    // Anything that isn't one of the presets is the customer's own colour.
    if (customDot) {
      var own = on && (!matched || source === 'custom');
      customDot.classList.toggle('is-picked', own);
      customDot.classList.toggle('is-dark', own && isDark(hex));
      if (own) {
        customDot.style.setProperty('--custom', hex);
        if (custom.value.toLowerCase() !== hex.toLowerCase()) custom.value = hex;
        dots.forEach(function (d) {
          d.setAttribute('aria-pressed', 'false');
        });
      }
    }
    try {
      localStorage.setItem(KEY, on ? hex : '');
    } catch (e) {}
  }

  dots.forEach(function (d) {
    d.addEventListener('click', function () {
      apply(d.dataset.wall, 'preset');
    });
  });
  if (custom) {
    custom.addEventListener('input', function () {
      apply(custom.value, 'custom');
    });
  }

  var saved = '';
  try {
    saved = localStorage.getItem(KEY) || '';
  } catch (e) {}
  if (HEX.test(saved)) apply(saved, 'restore');
})();
